var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 6.75,
    r: 3.25,
    stroke: "currentColor",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 18.25C2.75 14.95 5.22 12.25 8.25 12.25C10.03 12.25 11.62 13.18 12.63 14.63",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 16.75,
    r: 2.05,
    stroke: "currentColor",
    strokeWidth: 1.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.55V11.35M17.25 22.15V20.95M21.45 16.75H22.65M11.85 16.75H13.05M20.22 13.78L21.07 12.93M13.43 20.57L14.28 19.72M20.22 19.72L21.07 20.57M13.43 12.93L14.28 13.78",
    stroke: "currentColor",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettingsIcon);
export default __webpack_public_path__ + "static/media/profileSettingsIcon.3bdeae11361b9577753132d9cbbcbb46.svg";
export { ForwardRef as ReactComponent };